import { compose, getContext } from 'recompose'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { selectPropertyDetailsMapWithHome } from '../../../../store/selectors/airDna'

const FactTableContainer = compose(
  getContext({
    stateKey: PropTypes.string.isRequired,
    locked: PropTypes.bool,
  }),
  connect(
    (state, { stateKey }) => selectPropertyDetailsMapWithHome(state)[stateKey]
  )
)

export default FactTableContainer
